import budgetApp from "../../images/projects/budgetApp.png";
import covid from "../../images/projects/covid.png";
import leaderboard from "../../images/projects/leaderboard.png";
import TV from "../../images/projects/TV.png";

export const projects = [
  {
    id: 0,
    status: "Development",
    title: "BudgetApp",
    img: budgetApp,
    projectLink: "https://github.com/samiullahbahadur/budget-app",
    liveLink: "https://www.loom.com/share/aac95eefc99741a79ddb3bfb23670462",
  },
  {
    id: 1,
    status: "Development",
    title: "Covid-tracker",
    img: covid,
    projectLink: "https://github.com/samiullahbahadur/Covid-tracker",
    liveLink: "https://bahadur-covidtracker.netlify.app/",
  },
  {
    id: 2,
    status: "Development",
    title: "LeaderBoard",
    img: leaderboard,
    projectLink: "https://github.com/samiullahbahadur/LeaderBoard",
    liveLink: "https://bahadur-leaderboard.netlify.app/",
  },
  {
    id: 3,
    status: "Development",
    title: "TV-series-and-movies",
    img: TV,
    projectLink: "https://github.com/samiullahbahadur/TV-series-and-movies",
    liveLink: "https://tv-maize-zahra-pascal-samiullah-jscapstone.netlify.app/",
  },
];

export default "Project Data";
